/** TR05 copy (one group per control; a ticket edits only its own file). */
export const tr05PtBr = {
  title: 'Tarifas, juros, rendimentos e impostos de aplicação',
  description:
    'Eventos financeiros capturados no extrato contra a classificação e o lançamento efetivo de cada natureza.',
  reasons: {
    FEE_NOT_POSTED: 'Tarifas sem lançamento',
    FEE_POSTING_FAILED: 'Tarifas com lançamento recusado',
    FEE_POSTING_SKIPPED: 'Tarifas com lançamento ignorado',
    FEE_DUPLICATE_POSTING: 'Tarifas lançadas mais de uma vez',
    FEE_POSTING_AMOUNT_MISMATCH: 'Tarifas lançadas por outro valor',
    YIELD_NOT_POSTED: 'Rendimentos sem lançamento',
    YIELD_POSTING_FAILED: 'Rendimentos com lançamento recusado',
    YIELD_POSTING_SKIPPED: 'Rendimentos com lançamento ignorado',
    YIELD_DUPLICATE_POSTING: 'Rendimentos lançados mais de uma vez',
    YIELD_POSTING_AMOUNT_MISMATCH: 'Rendimentos lançados por outro valor (o bruto, quando há IRRF)',
    INVESTMENT_TAX_NOT_POSTED: 'Impostos de aplicação sem lançamento',
    INVESTMENT_TAX_POSTING_FAILED: 'Impostos de aplicação com lançamento recusado',
    INVESTMENT_TAX_POSTING_SKIPPED: 'Impostos de aplicação com lançamento ignorado',
    INVESTMENT_TAX_DUPLICATE_POSTING: 'Impostos de aplicação lançados mais de uma vez',
    INVESTMENT_TAX_POSTING_AMOUNT_MISMATCH: 'Impostos de aplicação lançados por outro valor',
    FINANCIAL_EVENT_UNCLASSIFIED: 'Movimentos financeiros sem classificação',
  },
  observations: {
    TR05_CAPTURED_EVENTS: 'Eventos financeiros avaliados: {{count}}',
    TR05_IMPORTED_HISTORY: 'No histórico importado (razão adotado, não lançado de novo): {{count}}',
    TR05_UNSUPPORTED_EVENT_TYPE: 'Operações internas de tipo não suportado: {{count}}',
    TR05_AMOUNT_BASIS_UNJUDGED:
      'Eventos fora da moeda funcional do livro (ou sem moeda definida), valor não comparado ao lançamento: {{count}}',
    TR05_RESTRICTED_ACCOUNT_FINDINGS: 'Pendências em contas com acesso restrito: {{count}}',
  },
};

export const tr05En: typeof tr05PtBr = {
  title: 'Fees, interest, yield and investment taxes',
  description:
    'Financial events captured on the statement against the classification and effective posting of each nature.',
  reasons: {
    FEE_NOT_POSTED: 'Fees not posted',
    FEE_POSTING_FAILED: 'Fees with a refused posting',
    FEE_POSTING_SKIPPED: 'Fees with a skipped posting',
    FEE_DUPLICATE_POSTING: 'Fees posted more than once',
    FEE_POSTING_AMOUNT_MISMATCH: 'Fees posted at another amount',
    YIELD_NOT_POSTED: 'Yield not posted',
    YIELD_POSTING_FAILED: 'Yield with a refused posting',
    YIELD_POSTING_SKIPPED: 'Yield with a skipped posting',
    YIELD_DUPLICATE_POSTING: 'Yield posted more than once',
    YIELD_POSTING_AMOUNT_MISMATCH: 'Yield posted at another amount (the gross, when IRRF applies)',
    INVESTMENT_TAX_NOT_POSTED: 'Investment taxes not posted',
    INVESTMENT_TAX_POSTING_FAILED: 'Investment taxes with a refused posting',
    INVESTMENT_TAX_POSTING_SKIPPED: 'Investment taxes with a skipped posting',
    INVESTMENT_TAX_DUPLICATE_POSTING: 'Investment taxes posted more than once',
    INVESTMENT_TAX_POSTING_AMOUNT_MISMATCH: 'Investment taxes posted at another amount',
    FINANCIAL_EVENT_UNCLASSIFIED: 'Unclassified financial movements',
  },
  observations: {
    TR05_CAPTURED_EVENTS: 'Financial events evaluated: {{count}}',
    TR05_IMPORTED_HISTORY:
      'Inside the imported history (adopted ledger, not posted again): {{count}}',
    TR05_UNSUPPORTED_EVENT_TYPE: 'Internal operations of an unsupported kind: {{count}}',
    TR05_AMOUNT_BASIS_UNJUDGED:
      'Events outside the book functional currency (or with no currency set), amount not compared to the posting: {{count}}',
    TR05_RESTRICTED_ACCOUNT_FINDINGS: 'Open items on restricted-access accounts: {{count}}',
  },
};
